if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      window.addEventListener('pageshow', this.resetSubmitState.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = evt.submitter || this.querySelector('[type="submit"]');
      const isBuyNow = submitButton.name === 'return_to';
      if (this.submitting) return;
      this.submitting = true;

      this.handleErrorMessage();
      if (!isBuyNow) this.cartNotification.setActiveElement(document.activeElement);

      this.querySelectorAll('[type="submit"]').forEach((button) => button.setAttribute('aria-disabled', true));
      submitButton.classList.add('loading');
      submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!isBuyNow) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      let redirecting = false;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (isBuyNow) {
            redirecting = true;
            window.location.href = submitButton.value;
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          this.handleErrorMessage(cartStrings.error);
          console.error(e);
        })
        .finally(() => {
          if (redirecting) return;
          this.resetSubmitState();
        });
    }

    resetSubmitState() {
      this.submitting = false;
      this.querySelectorAll('[type="submit"]').forEach((button) => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
